module.exports = __webpack_public_path__ + "static/media/md-hand.3735622c.svg";